import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Actions } from '@vantiva-sa/homesight_humaui/Utilities/Constants';
import { Divider, Tooltip } from 'antd';
import moment from 'moment';
import { ScheduleContactIcon, ScheduleNewContactIcon, GroupsIcon } from '../Common/Icons';
import NoReminderIcon from '../Common/Icons/NoReminderIcon.svg';
import {
  formatEventTimes,
  getTimeFormat,
  getTimeZoneFormat,
} from '@vantiva-sa/homesight_humaui/Utilities/DateTime';
import PropTypes from 'prop-types';
import { translator } from '@vantiva-sa/homesight_humaui/Store/configStore';
import { HSCard } from '@/Components/Common/HSWidget';

const TaskListItem = ({
  item,
  onActionClick,
  renderEventType,
  renderInvitedList,
  categoryOptions,
  loginUserTimeformat,
  userInfo,
  getRelativeTime,
  EventDaysInfo,
  DaysOfWeekRow,
  openSubMenu,
  hubRecord,
  renderButtonStatus,
  currentUser,
}) => {
  const trans = useSelector(translator);
  const currentUserData = useSelector((user) => user.data.userInfo);
  // Note: useruuid is not defined in the snippet.
  // Assuming useruuid should be obtained from hubRecord or elsewhere.
  const useruuid = currentUser?.useruuid; // Adjust as needed.
  const currentUserDataInfo = currentUserData[openSubMenu ? hubRecord?.useruuid : useruuid];
  const userTimezone = getTimeZoneFormat(currentUserDataInfo?.timezone);

  const [isNoRemainder, setIsNoRemainder] = useState(false);
  const [showRepeatInfo, setShowRepeatInfo] = useState(true);

  const getStatusLabel = (status) => {
    if (status === undefined || status === null || status === '') return null;

    switch (status) {
      case 'completed':
        return trans('COMPLETED');
      case 'expired':
        return trans('MISSED');
      case 'ongoing':
        return trans('INPROGRESS');
      case 'scheduled':
        return trans('SCHEDULED');
      default:
        return status?.charAt(0).toUpperCase() + status?.slice(1).toLowerCase();
    }
  };

  const truncateString = (str) => {
    if (!str) return '';

    if (str.length <= 15) {
      return str;
    }
    return str.slice(0, 15) + '...';
  };

  useEffect(() => {
    if (item?.reminder_minutes === -1) {
      setIsNoRemainder(true);
    } else {
      setIsNoRemainder(false);
    }
    if (item?.event_type === 'home_visit') {
      if ('repeat' in item) {
        setShowRepeatInfo(true);
      } else {
        setShowRepeatInfo(false);
      }
    }
  }, [item]);

  return (
    <>
      <HSCard
        key={item?.schedule_eventuuid}
        className="schedule-container-newui"
        style={{ cursor: 'pointer' }}
        onClick={
          item?.event_type === 'tasks'
            ? onActionClick(Actions.viewTask, item)
            : onActionClick(Actions.startEvent, item)
        }
        content={
          <>
            <div className="schedule-list-row1-newui">
              <div className="container-1">
                <div className="eventype-container">
                  {renderEventType(item?.event_type?.toLowerCase())}
                </div>
                {item?.eventType === 'schedule' || item?.eventType === 'zoom' ? (
                  <ScheduleNewContactIcon />
                ) : (
                  <div className="empty-action" style={{ width: '30px', marginLeft: '10px' }}>
                    {(() => {
                      const option = categoryOptions.find((opt) => opt.value === item?.category);
                      return option ? option.icon : '';
                    })()}
                  </div>
                )}
                <div className="schedule-eventname-newui">
                  <Tooltip title={item?.event_name} className="name">
                    {item?.event_name}
                  </Tooltip>
                </div>
              </div>
              <div className="container-2">
                {isNoRemainder && (
                  <div className="remainder-icon-container">
                    <NoReminderIcon className="no-remainder-icon" />
                  </div>
                )}
                <div title={userTimezone} className="schedule-eventtime-newui">
                  {item?.event_type !== 'tasks'
                    ? formatEventTimes(
                        item?.event_startdate,
                        item?.event_starttime,
                        item?.event_startdate,
                        item?.event_endtime,
                        userTimezone,
                        loginUserTimeformat?.is24hoursformat
                      )
                    : currentUserDataInfo && currentUserDataInfo?.is24hoursformat
                      ? getTimeFormat(
                          item?.event_timestamp,
                          userTimezone,
                          loginUserTimeformat?.is24hoursformat
                        )
                      : getTimeFormat(
                          item?.event_timestamp,
                          userTimezone,
                          loginUserTimeformat?.is24hoursformat
                        )}
                </div>
                {(item?.task_status || item?.event_status) && (
                  <div
                    className={`task-status-${item?.task_status || item?.event_status} task-status`}
                  >
                    {getStatusLabel(item?.task_status || item?.event_status)}
                  </div>
                )}
              </div>
            </div>
            <div className="schedule-list-row2-newui">
              <div className="schedule-list-row2-container1">
                {item?.event_type === 'schedule' || item?.event_type === 'zoom' ? (
                  <>
                    <div className="schedule-meeting-count">
                      <ScheduleContactIcon className="account-icon" />
                      {renderInvitedList(item?.invited_contacts).count > 0 && (
                        <div className="invited-count">
                          {renderInvitedList(item?.invited_contacts).count}
                        </div>
                      )}
                    </div>
                    <Divider type="vertical" />
                    <div className="invited-list">
                      {renderInvitedList(item?.invited_contacts).invitedContactsData}
                      {renderInvitedList(item?.invited_contacts).count > 3 && (
                        <div className="user-image-container user-more">
                          <span className="user-more-block">•••</span>
                        </div>
                      )}
                    </div>
                    <Divider type="vertical" />
                  </>
                ) : null}
                {item && (
                  <>
                    <div className="event_days_info">
                      {showRepeatInfo && <span>{trans('REPEATS:')}</span>}
                      <Tooltip title={EventDaysInfo(item?.days_of_week)} placement="bottom">
                        <>{DaysOfWeekRow(item?.days_of_week, item)}</>
                      </Tooltip>
                    </div>
                  </>
                )}
                {item && item?.groupuuid ? (
                  <>
                    <Divider type="vertical" />
                    <div className="group-schedule-information">
                      <div className="groups-schedule-typegroup">
                        <GroupsIcon className="groups-schedule-typegroup-icon" />
                        <span className="groups-schedule-typegroup-label">{trans('GROUP')}</span>
                      </div>
                      <Tooltip
                        title={(item?.group_name).length > 15 && truncateString(item?.group_name)}
                      >
                        <span className="groups-schedule-selected-label">
                          {item?.group_name ? truncateString(item?.group_name) : ''}
                        </span>
                      </Tooltip>
                    </div>
                  </>
                ) : null}
              </div>
              {item?.schedule_eventuuid &&
                moment(item?.event_timestamp).isSame(moment(), 'day') && (
                  <div
                    className="schedule-list-row2-container2"
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                  >
                    {renderButtonStatus(item)}
                  </div>
                )}
            </div>
          </>
        }
      />
    </>
  );
};

TaskListItem.propTypes = {
  item: PropTypes.shape({
    schedule_eventuuid: PropTypes.string.isRequired,
    event_type: PropTypes.string,
    eventType: PropTypes.string,
    event_name: PropTypes.string,
    event_startdate: PropTypes.string,
    event_starttime: PropTypes.string,
    event_enddate: PropTypes.string,
    event_endtime: PropTypes.string,
    reminder_minutes: PropTypes.number,
    event_timestamp: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    task_status: PropTypes.string,
    category: PropTypes.string,
    invited_contacts: PropTypes.array,
    days_of_week: PropTypes.array,
  }).isRequired,
  onActionClick: PropTypes.func.isRequired,
  renderEventType: PropTypes.func.isRequired,
  renderInvitedList: PropTypes.func.isRequired,
  categoryOptions: PropTypes.arrayOf(PropTypes.object).isRequired,
  loginUserTimeformat: PropTypes.shape({
    is24hoursformat: PropTypes.bool,
  }),
  userInfo: PropTypes.shape({
    is24hoursformat: PropTypes.bool,
  }),
  getRelativeTime: PropTypes.func.isRequired,
  EventDaysInfo: PropTypes.func.isRequired,
  DaysOfWeekRow: PropTypes.func.isRequired,
  openSubMenu: PropTypes.bool,
  hubRecord: PropTypes.object,
  renderButtonStatus: PropTypes.func.isRequired,
  currentUser: PropTypes.object,
};

export default TaskListItem;
